import { render, staticRenderFns } from "./AreaEditTabInfo.vue?vue&type=template&id=cbc406ee"
import script from "./AreaEditTabInfo.vue?vue&type=script&lang=ts"
export * from "./AreaEditTabInfo.vue?vue&type=script&lang=ts"
import style0 from "./AreaEditTabInfo.vue?vue&type=style&index=0&id=cbc406ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports